import { Icon, TextButton } from '@joor/design-system'

import { EmptyPayOrdersOverlayTestIds } from '../EmptyPayOrdersOverlay'
import { Body, Container, Header } from './Common.ui'

export function FiltersEmptyResultOverlay({ onLinkClick }: Props) {
  return (
    <Container>
      <Icon
        data-testid={EmptyPayOrdersOverlayTestIds.OverlayIconSearch}
        iconName="search"
        iconSize="extraLarge"
        plain
      />
      <Header>{CONTENT.HEADER_TEXT}</Header>
      <Body>
        {<TextButton onClick={onLinkClick}>{CONTENT.LINK_TEXT}</TextButton>}{' '}
        {CONTENT.BODY_TEXT}
      </Body>
    </Container>
  )
}

type Props = {
  onLinkClick: () => void
}

export const CONTENT = {
  HEADER_TEXT: 'No Results',
  LINK_TEXT: 'Clear',
  BODY_TEXT: 'or adjust your search criteria or filters and try again.',
}
